import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Ellipsis = _resolveComponent("Ellipsis")

  return (_openBlock(), _createBlock(_component_Ellipsis, {
    text: $props.text,
    style: _normalizeStyle($options.fit_style)
  }, null, 8 /* PROPS */, ["text", "style"]))
}